var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"danger","size":_vm.size,"disabled":_vm.isdisabled},on:{"click":_vm.DoCancel}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" 作废")])
}
var staticRenderFns = []

export { render, staticRenderFns }